import React, { ReactNode } from 'react';

export const GridItem = ({ children }: { children: ReactNode | ReactNode[] }): JSX.Element => {
  return <>{children}</>;
};
